import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppErrors, BadRequestError, NotFoundError } from '@fitness-force/models';;
import { environment } from '@fitness-force/environments';
import { OwnershipLevel } from '@fitness-force/enum';
import { catchError, map, Observable, throwError } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class ImageUploadService {
  private http = inject(HttpClient);

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  getUploadImagesByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_COMPANY_USER_UPLOAD_IMAGES;
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_FRANCHISE_USER_UPLOAD_IMAGES
          .replace('{franchise_group_id}', franchiseGroupId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_USER_UPLOAD_IMAGES
          .replace('{tenant_id}', tenantId.toString());
        break;
      default:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_USER_UPLOAD_IMAGES
          .replace('{tenant_id}', tenantId.toString());
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  UploadImagesByOwnership(ownership:OwnershipLevel,data:any, tenantId:number, franchiseGroupId:number): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.UPLOAD_COMPANY_USER_IMAGE;
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.UPLOAD_FRANCHISE_USER_IMAGE
          .replace('{franchise_group_id}', franchiseGroupId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.UPLOAD_USER_IMAGE
          .replace('{tenant_id}', tenantId.toString());
        break;
      default:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.UPLOAD_USER_IMAGE
          .replace('{tenant_id}', tenantId.toString());
        break;
    }
    return this.http.post(url, data, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

}
